import { render, staticRenderFns } from "./OfferEmailComplaint.vue?vue&type=template&id=345fe6ab&"
import script from "./OfferEmailComplaint.vue?vue&type=script&lang=js&"
export * from "./OfferEmailComplaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports